import { useEffect } from 'react'
import { Dialog, Flex, Portal, Text } from '@chakra-ui/react'
import { LuCircleCheckBig, LuCircleX } from 'react-icons/lu'
import { useAlertState, closeAlert } from '@/lib/alert'
import CustomDialogBackdrop from './CustomDialogBackdrop'

const DURATION = { success: 2000, error: 3000 }

const AlertModal = () => {
  const { type, title, message, open } = useAlertState()

  useEffect(() => {
    if (!open) return
    const timer = setTimeout(closeAlert, DURATION[type])
    return () => clearTimeout(timer)
  }, [open, type, message])

  return (
    <Dialog.Root
      open={open}
      onOpenChange={({ open }) => !open && closeAlert()}
      placement="center"
      size="xs"
      motionPreset="scale"
    >
      <Portal>
        <CustomDialogBackdrop />
        <Dialog.Positioner>
          <Dialog.Content m={6}>
            <Dialog.Body py={8} px={6}>
              <Flex direction="column" align="center" gap={4}>
                {type === 'success' ? (
                  <LuCircleCheckBig size={56} color="var(--chakra-colors-green-500)" />
                ) : (
                  <LuCircleX size={56} color="var(--chakra-colors-red-500)" />
                )}
                {title && (
                  <Text fontWeight="bold" fontSize="xl" textAlign="center">
                    {title}
                  </Text>
                )}
                <Text fontSize="md" textAlign="center" color="fg.muted">
                  {message}
                </Text>
              </Flex>
            </Dialog.Body>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  )
}

export default AlertModal
